module.exports = {
    getState: () => ({}),
    dispatch() {},
    subscribe() {},
    unsubscribe() {},
};
